import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
// import { updateCartDetails } from "@tw/header-footer/lib/redux/reducers";
import { addToCart, getProductInfo } from "../utils/apis";
import { getCSFrontendMsg } from '../utils/utility';
import { frontEndMessageCodes } from '../utils/Constants/Constants';
import {
  getProductStatus,
  renderDeliveryInfo,
  setNonStrictVariantsLS,
} from "../utils/helper";
import { toastMsg } from "../components/toastMessage/toastMessage";
import { trackAddToCart, ttqTrackEventBuryingPoint } from "../utils/analytics";
import useVariantSelection from "./useVariantSelection";
import { StatusPopup } from "../components/statusPopup/statusPopup";
import ProductActions from "../components/productActions/productActions";
import VariantDetails from "../components/variantDetails/variantDetails";
import VariantDrawerDesktop from "../components/variantDrawerDesktop/variantDrawerDesktop";
import VariantDrawerMobile from "../components/variantDrawerMobile/variantDrawerMobile";
import QuantityReminderPopup from "../components/QuantityReminderPopup/QuantityReminderPopup";
import { getRouter } from "../utils/helper";

const useAddToCart = ({ updateCartDetails, onSuccess, pageDetails }) => {
  const [openVariantDrawer, setOpenVariantDrawer] = useState(false);
  const [selectedPrentVariantCode, setSelectedParentVariantCode] =
    useState(null);
  const [selectedVariantCode, setSelectedVariantCode] = useState(null);
  const [isLoadingVariant, setIsLoadingVariant] = useState();
  const [productDetails, setProductDetails] = useState(null);
  const [initialQuantity, setInitialQuantity] = useState(1);
  const dispatch = useDispatch();
  const [details, setDetails] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [quantityReminderData, setQuantityReminderData] = useState({});
  const [showReminderModal, setShowReminderModal] = useState(false);

  const breakpoint = useSelector((state) => state.breakpoint);
  const router = getRouter();

  const onVariantSelect = (itemCode, nonStrictVariants) => {
    setNonStrictVariantsLS(nonStrictVariants);
    itemCode &&
      selectedVariantCode != itemCode &&
      setSelectedVariantCode(itemCode);
  };

  const [productInfo, setProductInfo] = useState({});
  const [cartQuantity, setCartQuantity] = useState(0);

  const onAddToCart = async (product, quantity, adaObj, switchFlag) => {
    const selectedQuantity = quantity || 1;
    setProductInfo(product);
    setCartQuantity(selectedQuantity)

    // if (product?.isParentSku || product?.isSOP) {
    if (product?.isSOP) {
      setOpenVariantDrawer(true);
      setSelectedVariantCode(product.itemCode);
      setSelectedParentVariantCode(product.itemCode);
      setInitialQuantity(selectedQuantity);
      return;
    }
    //  加价购处理逻辑 TEP-15551
    /**
     *  1、当前页面命中加价购活动
     *  2、当前页面路径中包含加价购页面路径 markup-purchase-products
     *  3、浏览器路径中包含参数 pageType=PDP
     *  4、浏览器路径中不包含参数 pageType=CART
    */
    if (product?.markupPurchase &&
      window.location.href.includes("markup-purchase-products")
    ) {
      onSuccess(product, quantity)
      return
    }
    // If product is related to 1+N bundle redirect to promotion page
    if (product?.bundlePromoCode) {
      router?.push(`/promotions/${product?.bundlePromoCode}`);
      return;
    }
    // TEP - 13260
    // let productStatusObj = getProductStatus(product?.productStatus);
    try {
      // if (
      //   product?.productStatus === "outOfStock" ||
      //   product?.productStatus === "notForSale" ||
      //   product?.productStatus === "upcoming"
      // ) {
      //   setDetails({
      //     ...product,
      //     productStatusLabel: productStatusObj?.label,
      //     msg: product.estimatedInstockTime,
      //   });
      //   setShowModal(true);
      //   return;
      // }

      if (product?.productStatus === "outOfStock" || product?.productStatus === "notForSale" || product?.productStatus === "upcoming") {
        let successMsg = await getCSFrontendMsg(frontEndMessageCodes.ADD_OUTOFSTOCK_CART);
        toastMsg(successMsg.message, '', successMsg.messageType);
        return;
      }

      if (quantityReminder(product, quantity)) return;

      await continueAddToCart(product, selectedQuantity, adaObj, switchFlag);

    } catch (err) {
      toastMsg(err?.response?.data?.message);
      console.error(err);
    }
  };

  const continueAddToCart = (product, selectedQuantity, adaObj, switchFlag) => {

    return new Promise(async (resolve, reject) => {
      const res = await addToCart(product.itemCode, selectedQuantity, {}, adaObj);
      if (res.status === 200) {
        /*  ===============================================  TEP-15578 ============================================= */
        const productItem = [{ ...product, quantity: selectedQuantity }]
        ttqTrackEventBuryingPoint('addToCart', productItem)
        /*  ===============================================  TEP-15578 ============================================= */
        trackAddToCart([product], [selectedQuantity], pageDetails);
        onSuccess && onSuccess(product.itemCode, switchFlag);
        updateCartDetails &&
          dispatch(
            updateCartDetails({
              id: "singleProduct",
              installment:
                res?.data?.data?.productList?.[0]?.saleAttributes?.find(
                  (attribute) => attribute?.key === "multi_dimension_payment"
                )?.value,
              totalQuantity: res?.data?.data?.totalQuantity,
              products: [{ product, quantity: selectedQuantity }],
            })
          );
        resolve();
      } else {
        toastMsg(res?.response?.data?.message);
        reject();
      }
    })

  }


  const quantityReminder = (product, quantity) => {

    const whetherItExistsInAnArr = (itemCode) => {
      const REMINDED_ITEM_CODE_ARR = JSON.parse(sessionStorage.getItem('REMINDED_ITEM_CODE_ARR')) ?? []
      return REMINDED_ITEM_CODE_ARR?.length > 0 ? REMINDED_ITEM_CODE_ARR?.includes(itemCode) : false
    }

    const productActivityList = product?.productActivityList;

    // 有活动商品 并且 满足数量 并且 没有打开过弹窗
    if (productActivityList && productActivityList.length != 0) {

      const productList = productActivityList.map((item, index) => {
        const activityConfig = item.activityConfig;
        if (item.activityType == 'popup') {
          const configList = activityConfig.triggerConfigList.map(t => ({
            itemCode: t.popupItemCode,
            number: t.popupTriggerNumber,
          })).filter(f => f.itemCode == product.itemCode && quantity >= f.number);
          return {
            index,
            type: item.activityType,
            title: activityConfig.popupTitle,
            confirmBtnText: activityConfig.popupConfirmWording,
            cancelBtnText: activityConfig.popupCancelWording,
            openCount: activityConfig.popupType,
            confirmUrl: activityConfig.popupConfirmUrl,
            // activityCode: activityConfig.activityCode,
            activityCode: product.itemCode,
            location: activityConfig.popupLocation,
            configList,
          }
        } else {
          const configList = activityConfig.fromToConfigList.map(t => ({
            itemCode: t.switchFromItemCode,
            number: t.switchFromItemQuantity,
          })).filter(f => f.itemCode == product.itemCode && quantity >= f.number);
          return {
            index,
            type: item.activityType,
            title: activityConfig.switchTitle,
            confirmBtnText: activityConfig.switchConfirmWording,
            cancelBtnText: activityConfig.switchCancelWording,
            openCount: activityConfig.switchType,
            // activityCode: activityConfig.activityCode,
            activityCode: product.itemCode,
            fromToConfigList: activityConfig.fromToConfigList,
            location: activityConfig.switchLocation,
            configList
          }
        }
      }).filter(item => {
        return item.location.includes('plp') && item.type == 'popup'
      })
      const configList = productList[0]?.configList;

      if (configList?.length) {
        if ((productList[0].openCount == 'once' && !whetherItExistsInAnArr(product.itemCode)) || productList[0].openCount == 'everytime') {
          setQuantityReminderData(productList[0]);
          setShowReminderModal(true);
          return true;
        }
      }

    }
  }

  const reminderCancel = async (fn) => {
    await continueAddToCart(productInfo, cartQuantity);
    fn();
  }

  const onSuccessDrawer = () => {
    onSuccess && onSuccess(selectedPrentVariantCode);
    setOpenVariantDrawer(false);
  };

  const {
    selectVariant,
    selectedVariant,
    isValidVariant,
    isSelectedValue,
    getSelectedVariantValue,
  } = useVariantSelection(
    productDetails && productDetails.variants,
    productDetails && productDetails.skuList,
    productDetails && productDetails.validVariants,
    onVariantSelect,
    selectedVariantCode
  );

  useEffect(() => {
    if (!selectedVariantCode || !openVariantDrawer) return;
    const getVariantDetails = async () => {
      try {
        setIsLoadingVariant(true);
        const res = await getProductInfo(selectedVariantCode);
        setProductDetails(res.data);
      } catch (err) {
        toastMsg("Something went wrong !");
        console.error(err);
      } finally {
        setIsLoadingVariant(false);
      }
    };

    getVariantDetails();
  }, [selectedVariantCode, openVariantDrawer]);

  // clean previous variant state after closing drawer
  useEffect(() => {
    if (!openVariantDrawer) setProductDetails(null);
  }, [openVariantDrawer]);

  const renderVariants = () => (
    <>
      {productDetails &&
        productDetails.variants &&
        productDetails.variants.map((variant, variantIndex) => (
          <VariantDetails
            variant={variant}
            variantIndex={variantIndex}
            selectedVariant={selectedVariant}
            selectVariant={selectVariant}
            isValidVariant={isValidVariant}
            isSelectedValue={isSelectedValue}
            getSelectedVariantValue={getSelectedVariantValue}
            key={variantIndex}
          />
        ))}
    </>
  );

  const renderDrawerFooter = () =>
    productDetails && (
      <ProductActions
        productInfo={productDetails?.info}
        onSuccess={onSuccessDrawer}
        productStatusObj={details.productStatus}
        initialQuantity={initialQuantity}
        updateCartDetails={updateCartDetails}
        disableAddToCart={isLoadingVariant}
        pageDetails={pageDetails}
      //onNotifyMeHandle={onNotifyMeHandle}
      />
    );

  const renderDrawerAndModal = () => {
    return (
      <>
        <StatusPopup
          showModal={showModal}
          setShowModal={setShowModal}
          product={details}
        />
        <QuantityReminderPopup
          breakpoint={breakpoint}
          {...quantityReminderData}
          showModal={showReminderModal}
          setShowModal={setShowReminderModal}
          onConfirm={() => setShowReminderModal(false)} // 加购没有 转化提醒
          onCancel={reminderCancel} // 加购没有 转化提醒
        />
        {breakpoint === "lg" ? (
          <VariantDrawerDesktop
            open={openVariantDrawer}
            onClose={() => setOpenVariantDrawer(false)}
            productInfo={productDetails?.info}
            renderVariants={renderVariants}
            renderFooter={renderDrawerFooter}
            renderAdditionalInfo={
              productDetails?.info?.isSOP && renderDeliveryInfo(productDetails)
            }
            productStatus={getProductStatus(productDetails?.info)}
            isLoadingVariant={isLoadingVariant}
          />
        ) : (
          <VariantDrawerMobile
            open={openVariantDrawer}
            setOpen={setOpenVariantDrawer}
            productInfo={productDetails?.info}
            renderVariants={renderVariants}
            renderFooter={renderDrawerFooter}
            renderAdditionalInfo={
              productDetails?.info?.isSOP && renderDeliveryInfo(productDetails)
            }
            productStatus={getProductStatus(productDetails?.info)}
            isLoadingVariant={isLoadingVariant}
            variantSelector={true}
          />
        )}
      </>
    );
  };

  return {
    onAddToCart,
    renderDrawerAndModal,
  };
};

export default useAddToCart;
